
export const ZIP_RUN_GREEN = '#2da700';

export const ZIP_RUN_GREEN_RGBA_LIGHT = 'rgba(94, 183, 11, .10)';